import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import { clearAuthStorage } from '@/utils/request'

Vue.use(Vuex)

const storedCorpid = VueCookies.get('v_corpid') || VueCookies.get('v_telcorpid') || localStorage.getItem('v_corpid') || ''
if (storedCorpid && !VueCookies.get('v_corpid')) VueCookies.set('v_corpid', storedCorpid)
const storedUserNo = VueCookies.get('v_telno') || VueCookies.get('v_teluser') || localStorage.getItem('v_telno') || ''
const storedUserName = VueCookies.get('v_usernm') || VueCookies.get('v_telusernm') || localStorage.getItem('v_usernm') || ''
if (storedUserNo && !VueCookies.get('v_telno')) VueCookies.set('v_telno', storedUserNo)
if (storedUserName && !VueCookies.get('v_usernm')) VueCookies.set('v_usernm', storedUserName)

export default new Vuex.Store({
  state: {
    baseUrl: process.env.VUE_APP_API_URL,
    LOADING: false,
    // 用户信息
    userInfo: {
      usernm: storedUserName,
      telno: storedUserNo,
      pwd: '',
      teluser: storedUserNo,
      telusernm: storedUserName,
      deptnm: localStorage.getItem('v_deptnm') || '',
      telpassword: '',
      telpwd: '',
      telcorpid: storedCorpid,
      telcorpnm: localStorage.getItem('v_telcorpnm') || '',
      idseq: localStorage.getItem('v_idseq') || '',
    }
  },
  mutations: {
    showLoading(state){
      state.LOADING=true
    },
    hideLoading(state){
      state.LOADING =false
    },
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = {
        ...state.userInfo,
        ...userInfo
      }
    },
    // 清除用户信息
    CLEAR_USER_INFO(state) {
      state.userInfo = {
        usernm: '',
        telno: '',
        pwd: '',
        teluser: '',
        telusernm: '',
        deptnm: '',
        telpassword: '',
        telpwd: '',
        telcorpid: '',
        telcorpnm: '',
        idseq: '',
      }
    }
  },
  actions: {
    // 登录成功后保存用户信息
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
      
      // 同时保存到 localStorage 和 cookies（保持向后兼容）
      if (userInfo.usernm) {
        localStorage.setItem('v_usernm', userInfo.usernm)
      }
      if (userInfo.telno) {
        localStorage.setItem('v_telno', userInfo.telno)
      }
      if (userInfo.telcorpid) {
        VueCookies.set('v_corpid', userInfo.telcorpid)
      }
      if (userInfo.idseq) {
        localStorage.setItem('v_idseq', userInfo.idseq)
      }
      if (userInfo.deptnm) {
        localStorage.setItem('v_deptnm', userInfo.deptnm)
      }
      if (userInfo.telcorpnm) {
        localStorage.setItem('v_telcorpnm', userInfo.telcorpnm)
      }
    },
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_USER_INFO')
      clearAuthStorage()
    }
  },
  getters: {
    // 获取用户名
    username: state => state.userInfo.usernm,
    // 获取用户编号
    userNo: state => state.userInfo.telno,
    // 获取公司ID
    corpId: state => state.userInfo.telcorpid,
    // 获取用户完整信息
    userInfo: state => state.userInfo,
    // 判断是否已登录
    isLoggedIn: state => !!state.userInfo.telno
  },
  modules: {
  }
})
